import { lazy } from 'react';

const LoadableRenameRoomModal = lazy(
  () => import(/* webpackChunkName: "damz-modals" */ './RenameRoomModal')
);

export default LoadableRenameRoomModal;
